import gql from 'graphql-tag'

const clientiSearch = gql`
  query clientiSearch (
    $search: String
    $limit: Int!
    $offset: Int
    $where: ClientiFilterInput
    $orderBy: [ClientiOrderBy]
  ) {
    clientiSearch (
      search: $search
      limit: $limit
      offset: $offset
      where: $where
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        agenteId
        agente {
          id
          nome
        }
        nome
        email
        email2
        telefono
        telefono2
        comune
        dataCreazione
        daRicontattare
        dataUltimaRichiesta
        dataUltimoContatto
        voto
        tipo
        nuovoClienteFlag
        telNonRisposte
        interessi {
          nome
        }
      }
    }
  }
`

export default clientiSearch



// WEBPACK FOOTER //
// ./src/graphql/queries/clientiSearch.js